import './style.scss'
import React from 'react'
import styled from 'styled-components'
import { tokens, rem, UIProps } from 'src/componentv2/Base/ui'

export interface AvatarProps extends UIProps {
    src?: string
    initials?: string
    alt?: string
    size?: string
}

const Box = styled.div<AvatarProps>`
    width: ${({ size }) => rem(size) ?? '3.2rem'};
    height: ${({ size }) => rem(size) ?? '3.2rem'};
    border-radius: 999rem;
    overflow: hidden;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${({ bgColor }) => bgColor ?? tokens.primarySoft};
    color: ${({ color }) => color ?? tokens.primaryDark};
    border: 2px solid ${tokens.white};
    font-size: ${({ fontSize }) => rem(fontSize) ?? '1.2rem'};
    font-weight: 600;
    flex-shrink: 0;

    img { width: 100%; height: 100%; object-fit: cover; }
`

export const Avatar: React.FC<AvatarProps> = ({
                                                  src, initials, alt = '', className = '', ...rest
                                              }) => (
    <Box className={`avatar ${className}`} {...rest}>
        {src ? <img src={src} alt={alt} /> : initials}
    </Box>
)

export default Avatar